import {
    OrderReferencesActions,
    UPSERT, CLEAR
} from './order-references.actions';

import { OrderReferences } from '../../shared/model';

export interface State {
    orderReferences: OrderReferences;
}

const initialState = {
    orderReferences: null
};

export function reducer(state = initialState, action: OrderReferencesActions) {
    switch (action.type) {
    case UPSERT:
        return {
            ...state,
            orderReferences: { ...state.orderReferences, ...action.payload },
        };
    case CLEAR:
        return {
            ...state,
            orderReferences: null,
        };
    default:
        return state;
    }
}

export const getOrderReferences = (state: State) => state.orderReferences;

